import { CloseCircleOutlined } from '@ant-design/icons';
import { Button, Result, Typography } from 'antd';

const { Paragraph, Text } = Typography;

type ErrorPageProps = {
  errorMsg?: string;
};

export const ErrorPage = ({ errorMsg }: ErrorPageProps) => {
  return (
    <Result
      status="error"
      title="User Authentication Failed"
      subTitle={errorMsg}
      extra={[
        <Button
          key="contact-support"
          type="link"
          href="https://circuit.intel.com/content/it/it-support/topic-pages/others/streamlined-access-approval-flow-saaf.html"
          target="_blank"
          rel="noreferrer"
        >
          Contact Support
        </Button>,
      ]}
    >
      <div className="desc">
        <Paragraph>
          <Text
            strong
            style={{
              fontSize: 16,
            }}
          >
            Please check the following:
          </Text>
        </Paragraph>
        <Paragraph>
          <CloseCircleOutlined className="site-result-demo-error-icon" /> You have connected to the Intel network thru
          VPN.
        </Paragraph>
        <Paragraph>
          <CloseCircleOutlined className="site-result-demo-error-icon" /> SAAF backend application is running.
        </Paragraph>
      </div>
    </Result>
  );
};
